import VanillaModal from 'vanilla-modal';
import Log from './log';

export default class videoModal {
  constructor() {
    // Elements
    this.videoModals = $('.js-video_modal');

    // Variables
    this.defaultOptions = {
      modal: '.modal',
      modalInner: '.modal-inner',
      modalContent: '.modal-content',
      open: '[data-modal-open]',
      close: '[data-modal-close]',
      page: 'body',
      loadClass: 'has-modal',
      class: 'has-modal--visible',
      clickOutside: true,
      closeKeys: [27],
      transitions: true,
      onBeforeOpen: null,
      onBeforeClose: videoModal.onModalClose,
      onOpen: videoModal.onModalOpen,
      onClose: null,
    };

    if (this.videoModals.length) {
      const modal = new VanillaModal(this.defaultOptions);
      this.videoModals.on('click', (event) => { videoModal.openModal(modal, event); });
    }
  }

  static openModal(modal, event) {
    event.preventDefault();
    const target = $(event.currentTarget).attr('href');
    modal.open(target);
    const title = $(event.currentTarget).data('film');
    Log.track('Video', 'played', `Trailer for ${title}`);
  }

  static onModalOpen() {
    const modalVideo = $('.modal-content .modal_video');
    const youtubeId = modalVideo.data('youtube-id');
    const vimeoId = modalVideo.data('vimeo-id');
    let template = '';
    if (youtubeId) {
      template = `<iframe src="//www.youtube.com/embed/${youtubeId}?controls=2&amp;byline=0&amp;autoplay=1" width="100%" height="148" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen=""></iframe>`;
    } else if (vimeoId) {
      template = `<iframe src="https://player.vimeo.com/video/${vimeoId}?autoplay=1&color=c9bb50&title=0&byline=0&portrait=0" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
    }
    modalVideo.html(template);
  }

  static onModalClose() {
    const modalVideo = $('.modal-content .modal_video');
    modalVideo.html('');
  }
}
